import React from 'react'

import './CardsLayout.scss'

const CardsLayout = ({ children }) => {
  return (
    <section className='frontend_cards-layout'>{children}</section>
  )
}

export default CardsLayout
